import {PdsWidget} from './pds-widget';

export class PdsOverlayDropdown extends PdsWidget {
  is = 'pds-overlay-dropdown';

  isReady: boolean;

  // If body is clicked we fire an event that signals to remove the overlay
  onBodyClick: (event: Event) => void;

  // If escape is pushed we fire an event that signals to remove the overlay
  onKeyDown: (event: KeyboardEvent) => void;

  // When the overlay is active the only clickable element will be the overlay's next element sibling.
  listeningSibling: Element;
  siblingClick: (event: Event) => void;
  siblingClicked = false;
  queuedEmit = false;

  // initialize property values (polymer hook)
  ready(): void {
    super.ready();
    this.isReady = false;
    this.queuedEmit = false;
    this.onBodyClick = (event: Event): void => {
      if (this.ready) {
        this.emitEscape();
      }
    };
    this.onKeyDown = (event: KeyboardEvent): void => {
      if (event.keyCode === 27) { //esc
        this.emitEscape();
      }
    };

    this.siblingClick = (ev: Event): void => {
      this.siblingClicked = true;
    };
  }

  // create event listeners (polymer hook)
  attached(): void {
    super.attached();
    setTimeout(() => {  // during attached element is in dom but sibling/parent pointers aren't correct. need set timeout
      this.listeningSibling = (<any>this).nextElementSibling;
      this.listeningSibling.addEventListener('click', this.siblingClick, true);
      window.addEventListener('keydown', this.onKeyDown);
      window.document.body.addEventListener('click', this.onBodyClick, true);
      setTimeout(() => {
        this.isReady = true;
      }, 0);
    });
  }

  // remove event listeners (polymer hook)
  detached(): void {
    super.detached();
    if (this.listeningSibling != null) {
      this.listeningSibling.removeEventListener('click', this.siblingClick, true);
    }
    window.removeEventListener('keydown', this.onKeyDown);
    window.document.body.removeEventListener('click', this.onBodyClick, true);
  }

  emitEscape(): void {
    //Once the emit has been queued, we don't need to run it again until it's been consumed by the deferred
    //function running in the setTimeout.
    if (!this.queuedEmit) {
      setTimeout(() => {
        if (this.siblingClicked === false) {
          this.fire('escape', true);
        } else {
          this.siblingClicked = false;
        }
        this.queuedEmit = false;
      });
      this.queuedEmit = true;
    }
  }

}
